import { Service } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Service()
export class TokenService {
  private token$: BehaviorSubject<string> = new BehaviorSubject('');

  getToken$(): Observable<string> {
    return this.token$;
  }

  setToken(value: string) {
    this.token$.next(value);
  }
}
